// Where the browser keeps its handle on a lead.
//
// Everything the funnel asks before the account card is written to a lead row
// as it is answered, and this token is what says which row. It survives a
// reload, a closed laptop and a week — which is the whole point, because until
// now those answers lived in a React state and nowhere else.
//
// The token is opaque and minted server-side: these writes carry no session, so
// a guessable handle would let anyone enumerate and overwrite other people's
// answers.
const KEY = "cxcash.onboarding.lead";

// Every access is guarded. A private window, or a browser set to block site
// data, throws on the accessor itself — the funnel should forget in that case,
// which is where it was before any of this, not break.
export function leadToken(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberLead(token: string) {
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    /* forgetting is the fallback */
  }
}

export function forgetLead() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* forgetting is the fallback */
  }
}
